module.exports = __webpack_public_path__ + "static/media/delivery_car.677467fc.png";